import classNames from 'classnames';
import React from 'react';

import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { FontSizeProps } from './models';
import styles from './styles.module.scss';

const FontSize: React.FunctionComponent<FontSizeProps> = (props) => {
  const { activeFontSize, fontSizes, toggleFontSize, onMouseEnter, onMouseLeave, onCloseDropdown, dataTestId = 'fontSize' } = props;

  return (
    <Dropdown className={styles.FontSize} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} dataTestId={`${dataTestId}-dropdown`}>
      {fontSizes.map((
        (fontSize, index) => {
          const className = classNames(styles.item, { [styles.active]: activeFontSize === fontSize });
          const onClick = (): void => toggleFontSize(fontSize);
          const onDoubleClick = (): void | undefined => onCloseDropdown && onCloseDropdown();

          return (<div key={fontSize} className={className} onClick={onClick}
            onDoubleClick={onDoubleClick} data-testid={`${dataTestId}-item${index}`}>
            {fontSize}
          </div>);
        }
      ))}
    </Dropdown>
  );
};

export default FontSize;
